import React from 'react';
import { MdDirectionsBus } from 'react-icons/md';

export const BusSpinner = () => {
    return (
        <div className="d-flex justify-content-center align-items-center my-4">
            <div className="position-relative" style={{ animation: 'spin 2s linear infinite' }}>
                <MdDirectionsBus className="text-primary" style={{ fontSize: '2.5rem' }} />
            </div>
            <style>{`
                @keyframes spin {
                    from {
                        transform: rotate(0deg);
                    }
                    to {
                        transform: rotate(360deg);
                    }
                }
            `}</style>
        </div>
    );
};
